import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const team = [
  { nom: "Bouchaib Khawla", poste: "Exposante — Marina Pro", bio: "Spécialiste en construction navale algérienne. Propose voiliers, sardiniers, semi-rigides et navires professionnels. Active depuis Oran et Béjaïa.", initiales: "BK", couleur: "#0d9488" }
];

const stats = [
  { valeur: "2 500+", label: "Annonces actives" },
  { valeur: "350+", label: "Exposants partenaires" },
  { valeur: "48 000+", label: "Utilisateurs inscrits" },
  { valeur: "10", label: "Wilayas couvertes" }
];

const valeurs = [
  { titre: "Transparence", desc: "Chaque annonce est vérifiée par notre équipe. Nous garantissons l'authenticité des informations publiées sur notre plateforme.", icon: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" },
  { titre: "Expertise", desc: "Notre équipe est composée de passionnés du nautisme avec une connaissance approfondie du marché maritime algérien.", icon: "M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" },
  { titre: "Proximité", desc: "Présents dans 10 wilayas côtières, nous connectons acheteurs et vendeurs partout en Algérie pour faciliter chaque transaction.", icon: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z" },
  { titre: "Innovation", desc: "Première plateforme maritime digitale en Algérie, nous intégrons les dernières technologies pour simplifier vos transactions.", icon: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" }
];

function APropos() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />

      {/* Hero */}
      <section className="page-banner" style={{
        position: "relative",
        backgroundImage: "url('https://images.unsplash.com/photo-1605281317010-fe5ffe798166?w=1920')",
        backgroundSize: "cover", backgroundPosition: "center",
        padding: "100px 50px", textAlign: "center"
      }}>
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.55)" }} />
        <div style={{ position: "relative" }}>
          <span style={{ display: "inline-block", backgroundColor: "#0d9488", color: "white", padding: "6px 18px", borderRadius: "20px", fontSize: "13px", fontWeight: "600", marginBottom: "20px", letterSpacing: "1px" }}>
            NOTRE HISTOIRE
          </span>
          <h1 style={{ fontSize: isMobile ? "30px" : "48px", fontWeight: "700", color: "white", marginBottom: "20px", lineHeight: "1.2" }}>
            La première plateforme<br />maritime en Algérie
          </h1>
          <p style={{ fontSize: "18px", color: "rgba(255,255,255,0.9)", maxWidth: "600px", margin: "0 auto", lineHeight: "1.7" }}>
            Depuis 2026, MarinaDZ connecte les professionnels et passionnés du maritime algérien avec les meilleures annonces du marché.
          </p>
        </div>
      </section>

      {/* Stats — ✅ 2 colonnes sur mobile */}
      <section style={{ backgroundColor: "#0d9488", padding: isMobile ? "30px 20px" : "50px" }}>
        <div style={{ maxWidth: "1000px", margin: "0 auto", display: "grid", gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(4, 1fr)", gap: isMobile ? "20px" : "30px", textAlign: "center" }}>
          {stats.map((stat, i) => (
            <div key={i}>
              <div style={{ fontSize: isMobile ? "28px" : "42px", fontWeight: "700", color: "white" }}>{stat.valeur}</div>
              <div style={{ fontSize: "13px", color: "rgba(255,255,255,0.8)", marginTop: "6px" }}>{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Mission */}
      <section className="section-padded" style={{ padding: "80px 50px", backgroundColor: "white" }}>
        <div className="grid-responsive" style={{ maxWidth: "1100px", margin: "0 auto", display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "60px", alignItems: "center" }}>
          <div>
            <span style={{ fontSize: "13px", fontWeight: "600", color: "#0d9488", letterSpacing: "1px", textTransform: "uppercase" }}>Notre Mission</span>
            <h2 style={{ fontSize: "34px", fontWeight: "700", color: "#1f2937", margin: "12px 0 20px", lineHeight: "1.3" }}>Démocratiser le maritime en Algérie</h2>
            <p style={{ fontSize: "15px", color: "#6b7280", lineHeight: "1.8", marginBottom: "20px" }}>
              L'Algérie possède 1 200 km de côtes méditerranéennes magnifiques, mais le secteur maritime manquait d'une plateforme moderne et professionnelle pour connecter les acteurs du marché.
            </p>
            <p style={{ fontSize: "15px", color: "#6b7280", lineHeight: "1.8", marginBottom: "30px" }}>
              MarinaDZ est née en 2026 de cette vision : Devenir le carrefour numérique du maritime  algérien, où acheteurs, vendeurs et professionnels se retrouvent pour développer ce secteur en plein essor.
            </p>
            <Link to="/catalogue" style={{ display: "inline-flex", alignItems: "center", gap: "8px", backgroundColor: "#0d9488", color: "white", padding: "13px 26px", borderRadius: "8px", textDecoration: "none", fontSize: "14px", fontWeight: "600" }}>
              Explorer le catalogue
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </Link>
          </div>
          <div style={{ position: "relative" }}>
            <img src="https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?w=700" alt="MarinaDZ mission" style={{ width: "100%", borderRadius: "16px", objectFit: "cover", height: "400px" }} />
            <div style={{ position: "absolute", bottom: "-20px", left: "-20px", backgroundColor: "white", borderRadius: "12px", padding: "20px 24px", boxShadow: "0 8px 30px rgba(0,0,0,0.15)" }}>
              <div style={{ fontSize: "28px", fontWeight: "700", color: "#0d9488" }}>2026</div>
              <div style={{ fontSize: "13px", color: "#6b7280" }}>Année de fondation</div>
            </div>
          </div>
        </div>
      </section>

      {/* Valeurs */}
      <section className="section-padded" style={{ padding: "80px 50px", backgroundColor: "#f9fafb" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "50px" }}>
            <h2 style={{ fontSize: "32px", fontWeight: "700", color: "#1f2937", marginBottom: "12px" }}>Nos Valeurs</h2>
            <p style={{ fontSize: "16px", color: "#6b7280" }}>Les principes qui guident chacune de nos actions</p>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)", gap: "24px" }}>
            {valeurs.map((v, i) => (
              <div key={i} style={{ backgroundColor: "white", borderRadius: "14px", padding: "30px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", display: "flex", gap: "20px", borderLeft: "4px solid #0d9488" }}>
                <div style={{ width: "50px", height: "50px", borderRadius: "12px", backgroundColor: "#f0fdfa", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0d9488" strokeWidth="2"><path d={v.icon}/></svg>
                </div>
                <div>
                  <h3 style={{ fontSize: "17px", fontWeight: "700", color: "#1f2937", marginBottom: "8px" }}>{v.titre}</h3>
                  <p style={{ fontSize: "14px", color: "#6b7280", lineHeight: "1.6" }}>{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Équipe */}
      <section className="section-padded" style={{ padding: "80px 50px", backgroundColor: "white" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "50px" }}>
            <h2 style={{ fontSize: "32px", fontWeight: "700", color: "#1f2937", marginBottom: "12px" }}>Notre Équipe</h2>
            <p style={{ fontSize: "16px", color: "#6b7280" }}>Des passionnés du secteur maritime à votre service</p>
          </div>
          <div className="grid-responsive" style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(4, 1fr)", gap: "24px" }}>
            {team.map((membre, i) => (
              <div key={i} style={{ backgroundColor: "#f9fafb", borderRadius: "14px", padding: "28px 20px", textAlign: "center", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                <div style={{ width: "72px", height: "72px", borderRadius: "50%", margin: "0 auto 16px", backgroundColor: membre.couleur, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px", fontWeight: "700", color: "white" }}>
                  {membre.initiales}
                </div>
                <h3 style={{ fontSize: "15px", fontWeight: "700", color: "#1f2937", marginBottom: "4px" }}>{membre.nom}</h3>
                <p style={{ fontSize: "12px", color: "#0d9488", fontWeight: "600", marginBottom: "10px" }}>{membre.poste}</p>
                <p style={{ fontSize: "13px", color: "#6b7280", lineHeight: "1.5" }}>{membre.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padded" style={{ padding: "80px 50px", backgroundColor: "#0d9488", textAlign: "center" }}>
        <div style={{ maxWidth: "600px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "30px", fontWeight: "700", color: "white", marginBottom: "15px" }}>Rejoignez notre communauté</h2>
          <p style={{ fontSize: "16px", color: "rgba(255,255,255,0.9)", marginBottom: "35px" }}>
            Que vous soyez acheteur ou professionnel, MarinaDZ est votre partenaire maritime de confiance depuis 2026.
          </p>
          <div style={{ display: "flex", gap: "15px", justifyContent: "center", flexWrap: "wrap" }}>
            <Link to="/inscription" style={{ backgroundColor: "white", color: "#0d9488", padding: "13px 28px", borderRadius: "8px", textDecoration: "none", fontSize: "15px", fontWeight: "700" }}>
              S'inscrire gratuitement
            </Link>
            <Link to="/contact" style={{ backgroundColor: "transparent", color: "white", padding: "13px 28px", borderRadius: "8px", textDecoration: "none", fontSize: "15px", fontWeight: "600", border: "2px solid rgba(255,255,255,0.6)" }}>
              Nous contacter
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default APropos;